import { domainMap } from './domainMap';

let apiDomain = '';

if (process.env.NODE_ENV !== 'production') {
  apiDomain = process.env.REACT_APP_API_DOMAIN as string;
} else {
  // for older IE and firefox web/android compatibilty
  if (!window.location.origin) {
    // @ts-ignore: origin is a readable property in all new browsers but writing to it for older browser compatibility
    window.location.origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  }

  const [protocol, host] = window.location.origin.split('://');

  const frontendDomains = Object.keys(domainMap);
  frontendDomains.forEach((frontendDomain) => {
    const regex = new RegExp(`^${frontendDomain}`, 'g');
    if (regex.test(host)) {
      apiDomain = `${protocol}://${domainMap[frontendDomain]}`;
      // Break out of the loop by truncating array
      frontendDomains.length = 0;
    }
  });
}

const API_DOMAIN = apiDomain;
export default API_DOMAIN;
